<template>
  <div class="van-doc-simulator">
    <heads :msg="atitle"></heads>
    <div class="div_read_port">
      <span class="line" />
      <span class="p_read_port">掌握度</span>
      <span class="line" />
    </div>
    <!-- dataList -->
    <div class="study_report_content">
      <el-tree class="myTree" :data="dataList" :props="defaultParams" :indent="15" icon-class="el-icon-arrow-right" :default-expand-all="true" :expand-on-click-node="false" @node-click="handleNodeClick">
        <template slot-scope="{node,data}">
          <div class="treeCell">
            <div class="treeCellTitle">
              <span class="title">
                <span v-if="data.item_typestr">[{{ data.item_typestr }}] </span>
                {{ data.name }}
              </span>
            </div>
            <div v-if="data.do_num > 0 && (data.correct_rate || data.correct_rate == 0)" class="treeCellCircle">
              <van-circle v-model="data.correct_rate" :rate="data.correct_rate" size="38" color="#ee2e2e" stroke-width="120" layer-color="#ebedf0" :text="data.correct_rate + '%'" />
            </div>
          </div>
        </template>
      </el-tree>
    </div>
  </div>
</template>

<script>
import '@/components/css/setting.css'
import Cookies from 'js-cookie'
import { getReport } from '@/api/zkbproEdu.js'

export default {
  components: {
  },
  data() {
    return {
      atitle: '学习报告',
      // 分类id
      category_id: '',
      category_name: '',
      // 通过分类获取课程，选择的课程id和名称
      combine_id: '',
      combine_name: '',
      source_id: this.$route.query.source_id || '',
      source_type: '3',
      lesson_id: '',
      class_id: '',
      num: 0,
      progress: 0,
      rate: 0,
      activeNames: [],
      dataList: [],
      defaultParams: {
        label: 'courseware_title',
        children: 'children'
      }
    }
  },
  created() {
    this.source_id = this.$route.query.source_id || ''
    this.lesson_id = this.$route.query.lesson_id || ''
    this.class_id = this.$route.query.class_id || ''
    this.changedCombine()
  },
  methods: {
    // 头部切换课程
    changedCombine() {
      // 获取学习报告
      this.getReportFunc()
    },
    // 获取学习报告
    getReportFunc() {
      const params = {
        source_id: this.source_id,
        source_type: this.source_type
      }
      getReport(params).then(res => {
        if (res.errNo == 0) {
          const result = res.result || []
          // result.forEach(ele => {
          //   ele.correct_rate = 10
          // })
          this.dataList = result
        }
      })
    },
    // tree cell click
    handleNodeClick(data) {
    }

  }
}
</script>
<style lang="scss" scoped>
.grayLine {
  width: 100%;
  height: 20px;
  background-color: #F8F8F8;
}
.div_read_port {
  text-align: center;
  height: 40px;
  padding-top: 15px;
  padding-bottom: 15px;
  justify-content: center;
  align-items: center;
  background: #eeeeee;
  margin-top: 10px;
  .p_read_port {
    font-size: 28px;
    font-weight: 400;
    margin-left: 20px;
    margin-right: 20px;
    color: #999999;
    line-height: 40px;
  }

  .line {
    display: inline-block;
    width: 240px;
    margin-bottom: 10px;
    border: 1px solid #cccccc;
  }
}
.div_bottom_boder {
  border-bottom: #eeeeee 1px solid;
}

.div_bottom {
  // height: 102px;
  background: white;
  margin-left: 64px;
  border-left: #eeeeee 1px solid;

  .item_content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .item_content_third {
    // border-top:#eeeeee 1px solid;
    // border-left: #eeeeee 1px solid;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // width: calc(100% - 30PX);
    .left {
      width: 460px !important;
    }
  }

  .left {
    position: relative;
    display: flex;
    align-items: center;
    // flex: 1;
    text-align: left;
    width: 530px;
    .title {
      height: 40px;
      font-size: 28px;
      font-weight: 500;
      max-width: 560px;
      color: #333333;
      margin-top: 5px;
      line-height: 40px;
      margin-left: 28px;
      display: inline-block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .iv_icon {
      position: absolute;
      left: -16px;
    }
  }

  .right {
    margin-right: 30px;
  }
}

/deep/ .van-circle__text {
  font-size: 20px;
  font-weight: 400;
  color: #ee2e2e;
  line-height: 28px;
}

.van_circle {
  margin-top: 10px;
}

.iv_icon {
  display: block;
  width: 30px;
  height: 30px;
  margin-bottom: 0px;
  margin-right: 10px;
}

/deep/ .van-cell__title {
  width: 100%;
  display: flex;
  margin-left: 30px;
  align-items: center;
}

/deep/ .van-divider {
  display: flex;
  align-items: center;
  margin: 0 auto;
}

/deep/ .van-collapse-item__content {
  padding: 0px 16px;
}

/deep/ .van-cell {
  padding: 30px 0px;
  border-bottom: #eeeeee 1px solid;
  border-top: #eeeeee 1px solid;
}
.opacity {
  opacity: 0;
}

// 树形结构列表样式
.myTree {
  padding: 10px 20px 30px;
  background-color: #fff;
  /deep/.el-tree-node__content {
    background-color: #fff;
    padding: 20px 0;
    height: auto !important;
    border-bottom: 1px solid #ddd;
  }
  /deep/.el-tree-node__content > .el-tree-node__expand-icon {
    padding: 6px;
    position: absolute;
    right: 25px;
    color: #999;
    transform: rotate(90deg) scale(1.5);
  }
  /deep/.el-tree-node__expand-icon.expanded {
    transform: rotate(270deg) scale(1.5);
  }
  /deep/.el-tree-node__expand-icon.is-leaf {
    color: transparent;
    cursor: default;
  }
  // /deep/.el-tree-node__content > .el-tree-node__expand-icon {
  //   background-color: lawngreen;
  // }
  .treeCell {
    width: calc(100% - 60px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
  }
  .treeCellTitle {
    margin-left: 5px;
    // 和里层的不能删
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .title {
      // font-family: PingFangSC-Medium, PingFang SC;
      font-size: 28px;
      color: #333;
      font-weight: 500;
      // 和外部的不能删
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .treeCellCircle {
    display: flex;
    align-items: center;
  }
}
</style>
